export const GUEST_ID_KEY = 'ndc.presence.guestId';
export const GUEST_ID_HEADER = 'X-Guest-Id';

let ephemeralGuestId: string | null = null;

/**
 * Anonymous visitor id shared by presence heartbeats and playback session starts (X-Guest-Id), so the admin live view
 * can link a guest's presence to what they are watching. Display only - never used for authorization.
 */
export function getOrCreateGuestId(): string {
  try {
    const existing = localStorage.getItem(GUEST_ID_KEY);
    if (existing) {
      return existing;
    }

    const created = crypto.randomUUID();
    localStorage.setItem(GUEST_ID_KEY, created);
    return created;
  } catch {
    // Storage blocked: keep one id for this page load.
    ephemeralGuestId ??= `ephemeral-${Date.now()}`;
    return ephemeralGuestId;
  }
}
